import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import StatsCard from '../../components/admin/StatsCard';
import CurrentPlanBanner from '../../components/subscription/CurrentPlanBanner';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { sellerService } from '../../services/seller.service';
import { theme } from '../../config/theme';
import { formatCurrency } from '../../utils/helpers';
import { PackageIcon, ShoppingBagIcon, DollarIcon } from '../../components/icons/Icons';

const SellerDashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await sellerService.getDashboard();
      setData(response.data);
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        navigate('/seller/onboarding/status');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner fullScreen />;

  const { seller, analytics, subscription } = data || {};

  // Map subscription data from dashboard API (camelCase) to
  // the shape CurrentPlanBanner expects (snake_case seller fields)
  const planInfo = subscription ? {
    tier: subscription.current,
    subscription_status: subscription.status,
    product_limit: subscription.productLimit,
    products_used: subscription.productsUsed,
    subscription_end_date: subscription.subscriptionEndDate,
  } : null;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        <h1 style={{ fontSize: theme.typography.fontSize['3xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xs }}>
          {seller?.store_name}
        </h1>
        <p style={{ color: theme.colors.text.secondary, marginBottom: theme.spacing.xl }}>Seller Dashboard</p>

        {/* Compact plan banner */}
        {planInfo && (
          <div style={{ marginBottom: theme.spacing.xl }}>
            <CurrentPlanBanner seller={planInfo} compact />
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: theme.spacing.lg }}>
          <StatsCard
            title="Total Products"
            value={analytics?.products?.total || 0}
            icon={<PackageIcon size={32} />}
          />
          <StatsCard
            title="Total Orders"
            value={analytics?.orders?.total || 0}
            icon={<ShoppingBagIcon size={32} />}
          />
          <StatsCard
            title="Total Revenue"
            value={formatCurrency(analytics?.revenue?.total || 0)}
            icon={<DollarIcon size={32} />}
          />
          <StatsCard
            title="Your Earnings"
            value={formatCurrency(analytics?.revenue?.earnings || 0)}
            icon={<DollarIcon size={32} />}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default SellerDashboard;